import { useEffect, useState } from 'react';
import { Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import './MarkerCustom.css'
import config from '../config.json'
import MarkerPopupNormal from './MarkerPopupNormal'
import MarkerPopupNoCredit from './MarkerPopupNoCredit'

const getColor = (item) => {
  if ("dtFa" in item && item.dtFa.includes("*"))
    return !item.validLastLocation ? "bg-warning" : "bg-success";
  return "bg-danger";
};

const getVehicleHeading = (item) => {
  if (!('heading' in item) || item.heading < 1)
    return null;
  const heading = Number(item.heading);
  if (!Number.isFinite(heading))
    return null;

  // تبدیل هر زاویه‌ای به بازه 0 تا 359
  return ((heading % 360) + 360) % 360;
};

const getMarkerHTML = (item, defaultDevice, showHint) => {
  const heading = getVehicleHeading(item);
  const hasHeading = heading !== null;

  const isActive = defaultDevice === item;
  const color = getColor(item);
  const showSmoke = item.switch === 1 || item.shock === 1;
  const showTrail = item.speed > 5;
  const showSimWarning = item.chargeSimCard > 0 && item.chargeSimCard <= 10000;
  const showBatteryWarning = item.battery < 5;
  const isInvalidLocation = (item.latitude < 1 && item.longitude < 1);
  return `
    ${isActive ? "<div class='marker-pin1'><div class='marker-pin21'>" : ""}
    ${showTrail ? "<div class='tractor-wrapper'><div class='plow-track'></div>" : ""}
    <div class="tractor-icon-container">
    <div
        class="vehicle-heading ${hasHeading ? "has-heading" : "no-heading"}"
        style="--vehicle-heading: ${hasHeading ? heading : 0}deg;"
      >
      <img class='tractor-icon ${item.speed > 5 ? "plowing" : ""} mainMarkerIcon ${item.dtFa?.includes("*") ? "App-logo" : ""}' 
           src=${item.icon && item.icon !== '' ? `${config.apiUrl}/piccar/${item.icon}` : '/images/car1.png'} />
            ${hasHeading && item.speed > 2
      ? `
              <span class="vehicle-direction-arrow"></span>
            `
      : ""
    }
      </div>
      ${showSmoke ? `
        <div class="smoke-container">
          <span class="smoke puff1"></span>
          <span class="smoke puff2"></span>
          <span class="smoke puff3"></span>
        </div>` : ""}
     ${(showHint && !isInvalidLocation) ? `
        <div class="marker-hint bounce" id="marker-hint">
          👆 برای مشاهده اطلاعات کلیک کنید
        </div>` : ""}
        ${(isInvalidLocation) ? `
        <div class="marker-InvalidLocation bounce" id="marker-hint">
         🚗  عدم آنتن دهی Gps<br/>
          👆 برای مشاهده اطلاعات کلیک کنید
        </div>` : ""}
    </div>
    ${showTrail ? "</div>" : ""}
    ${isActive ? "</div></div>" : ""}
    <div class='markerLabel shadow-sm'>
      ${item.deviceName}
      <div class="avatars">
        ${showSimWarning ? '<span class="avatar"><img src="/simCharge2.png" /></span>' : ""}
        ${showBatteryWarning ? '<span class="avatar"><img src="/car-battery-32.png"/></span>' : ""}
      </div>
      <span class="position-absolute start-100 translate-middle p-2 ${color} border border-light rounded-circle ${color === "bg-success" ? "pulse-ring pulse-bg-success" : ""}">
        <span class="visually-hidden">New alerts</span>
      </span>
    </div>
  `;
};


const getMarkerHTMLOld = (item, defaultDevice) => {
  const isActive = defaultDevice === item;
  const color = getColor(item);
  const showSmoke = item.switch === 1 || item.shock === 1;
  const showTrail = item.speed > 5;
  const showSimWarning = item.chargeSimCard > 0 && item.chargeSimCard <= 10000;
  const showBatteryWarning = item.battery < 5;

  return `
    ${isActive ? "<div class='marker-pin1'><div class='marker-pin21'>" : ""}
    ${showTrail ? "<div class='tractor-wrapper'><div class='plow-track'></div>" : ""}
    <div class="tractor-icon-container">
      <img class='tractor-icon ${item.speed > 5 ? "plowing" : ""} mainMarkerIcon ${item.dtFa?.includes("*") ? "App-logo" : ""}' 
           src=${item.icon && item.icon !== '' ? `${config.apiUrl}/piccar/${item.icon}` : '/images/car1.png'} />
      ${showSmoke ? `
        <div class="smoke-container">
          <span class="smoke puff1"></span>
          <span class="smoke puff2"></span>
          <span class="smoke puff3"></span>
        </div>` : ""}
    </div>
    ${showTrail ? "</div>" : ""}
    ${isActive ? "</div></div>" : ""}
    <div class='markerLabel shadow-sm'>
      ${item.deviceName}
      <div class="avatars">
        ${showSimWarning ? '<span class="avatar"><img src="/simCharge2.png" /></span>' : ""}
        ${showBatteryWarning ? '<span class="avatar"><img src="/car-battery-32.png"/></span>' : ""}
      </div>
      <span class="position-absolute start-100 translate-middle p-2 ${color} border border-light rounded-circle ${color === "bg-success" ? "pulse-ring pulse-bg-success" : ""}">
        <span class="visually-hidden">New alerts</span>
      </span>
    </div>
  `;
};

export default function MarkerCustom({ item, showCredit, defaultDevice }) {
  const localstorageName = 'markerHintShown2'
  const [showHint, setShowHint] = useState(false);
  useEffect(() => {
    const hintShown = localStorage.getItem(localstorageName);
    if (!hintShown) {
      setShowHint(true);
    }
  }, []);

  useEffect(() => {
    if (!showHint) return;

    const handler = (e) => {
      if (e.target.classList.contains('marker-hint')) {
        localStorage.setItem(localstorageName, 'true');
        setShowHint(false);

        // حذف همه راهنماها از DOM
        document.querySelectorAll('.marker-hint').forEach(el => el.remove());
      }
    };

    document.addEventListener('click', handler);
    return () => { document.removeEventListener('click', handler); };
  }, [showHint]);


  const icon = new L.divIcon({
    html: getMarkerHTML(item, defaultDevice, showHint),
    className: "text-below-marker",
  });


  return (
    <Marker position={[item.latitude, item.longitude]} icon={icon} customData={item}>
      <Popup>
        {item.dayActive > 0 ? (
          <MarkerPopupNormal item={item} />
        ) : (
          <MarkerPopupNoCredit item={item} showCredit={showCredit} />
        )}
      </Popup>
    </Marker>
  );
}
